import { ReservationType } from '@user-history/entities/user-history-item';

export const AssetCrossSelling = {
  ASSISTANCE_LIST: [],
  ASSISTANCE_DETAIL: [],
  PRODUCT_DETAIL: [
    ReservationType.Flight,
    ReservationType.AirPackage
  ],
  PRODUCT_LIST: []
};
